/**
 * Shared currency / number formatters for the Nut Sheet summary tables.
 */

export function formatCurrency(value: number): string {
  if (!Number.isFinite(value)) return '$0';
  const sign = value < 0 ? '-' : '';
  const abs = Math.abs(value);
  return `${sign}$${abs.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
}

/**
 * Currency with an explicit leading sign: "+$35" for positive, "-$30" for
 * negative, "$0" for zero. Used on the Adjustments line so the sign reflects
 * the direction the gross moves (Actual − Est: + = gross went up).
 */
export function formatCurrencySigned(value: number): string {
  if (value > 0) return `+${formatCurrency(value)}`;
  return formatCurrency(value); // negatives already carry "-"; zero → "$0"
}

export function formatInt(value: number): string {
  if (!Number.isFinite(value)) return '0';
  return value.toLocaleString('en-US');
}

export function parseCurrencyInput(input: string): number | null {
  const cleaned = input.replace(/[$,\s]/g, '').trim();
  if (cleaned === '' || cleaned === '-') return null;
  const n = Number(cleaned);
  return Number.isFinite(n) ? n : null;
}

/**
 * Parse a field that accepts EITHER a dollar amount OR free text — used by the
 * Nut Sheet trade Retail column, where an operator may type a note like
 * "Auction" instead of a number. Numeric-looking input becomes a number (so it
 * currency-formats on blur, $1,500); anything else is kept as the trimmed raw
 * string; empty → null.
 */
export function parseCurrencyOrText(input: string): number | string | null {
  const trimmed = input.trim();
  if (trimmed === '') return null;
  const cleaned = trimmed.replace(/[$,\s]/g, '');
  const n = Number(cleaned);
  if (cleaned !== '' && Number.isFinite(n)) return n;
  return trimmed;
}
